import MediaGrid from "./MediaGrid"
import MediaCarousel from "./MediaCarousel"
import PropTypes from "prop-types"
import React, { useState } from "react"
import { VideoPlayerModal } from "ui/VideoPlayerModal"
import { isMediaFileVideo, getMediaUrl } from "utils/media-upload"
import { useDevice } from "hooks/useDevice"
import styles from "../ExperiencesPreview.module.css"

const buildSortedMedia = (photos, cropped_photos, videos, trimmed_videos) => {
  const media = [
    ...photos.map((photo) => ({ ...photo, type: "photo" })),
    ...cropped_photos.map((photo) => ({ ...photo, type: "cropped_photo" })),
    ...videos.map((video) => ({ ...video, type: "video" })),
    ...trimmed_videos.map((video) => ({
      ...video,
      type: "trimmed_video",
      thumbnail_url: getMediaUrl(video)
    }))
  ]
  return [...media].sort((a, b) => (a.position || 0) - (b.position || 0))
}

const PreviewMediaListingComponent = ({ trip, embedded }) => {
  const [videoModalOpen, setVideoModalOpen] = useState(false)
  const [selectedMedia, setSelectedMedia] = useState(null)
  const { isMobile } = useDevice()

  const { photos = [], cropped_photos = [], videos = [], trimmed_videos = [] } = trip
  const sortedMedia = buildSortedMedia(photos, cropped_photos, videos, trimmed_videos)

  const handleMediaClick = (media) => {
    if (isMediaFileVideo(media)) {
      setSelectedMedia(media)
      setVideoModalOpen(true)
    }
  }

  const handleCloseVideoModal = () => {
    setVideoModalOpen(false)
    setSelectedMedia(null)
  }

  return (
    <div className={embedded ? styles.embeddedMediaWrapper : ""}>
      {isMobile ? (
        <div style={{ height: 300, marginTop: 15 }}>
          <MediaCarousel
            photos={sortedMedia}
            ratio={null}
            slidesPerView={1}
            className="w-100"
            embedded={embedded}
            onMediaClick={handleMediaClick}
          />
        </div>
      ) : (
        <MediaGrid photos={sortedMedia} handleMediaClick={handleMediaClick} embedded={embedded} />
      )}
      <VideoPlayerModal
        open={videoModalOpen}
        handleClose={handleCloseVideoModal}
        selectedMedia={selectedMedia}
        embedded={embedded}
      />
    </div>
  )
}

PreviewMediaListingComponent.propTypes = {
  trip: PropTypes.shape({
    photos: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        url: PropTypes.string.isRequired,
        placeholder_url: PropTypes.string,
        position: PropTypes.number
      })
    ),
    cropped_photos: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        url: PropTypes.string.isRequired,
        placeholder_url: PropTypes.string,
        position: PropTypes.number
      })
    ),
    videos: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        url: PropTypes.string.isRequired,
        placeholder_url: PropTypes.string,
        type: PropTypes.string,
        position: PropTypes.number
      })
    ),
    trimmed_videos: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        url: PropTypes.string.isRequired,
        placeholder_url: PropTypes.string,
        preview_url: PropTypes.string,
        thumbnail_url: PropTypes.string,
        type: PropTypes.string,
        position: PropTypes.number
      })
    )
  }).isRequired,
  embedded: PropTypes.bool
}

export const PreviewMediaListing = React.memo(PreviewMediaListingComponent)
